<template>
  <div class="banner">
    <div class="banner-text" v-show="key == '/home'">
        <p>多开分身</p>
        <p style="margin-left: 100px;">安全稳定</p>
    </div>
    <div class="banner-text" v-show="key == '/reports'">
        <p>关于我们</p>
    </div>
    <div class="banner-text" v-show="key == '/down'">
        <p>应用下载</p>
    </div>
    <img :src="url" alt="">
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      url: require('../assets/banner.png')
    }
  },
  watch: {},
  computed: {
    key() {
      return this.$route.path
    }
  },
  methods: {},
  created () {},
  mounted () {}
}
</script>
<style scoped>
.banner {
  width: 100%;
  /* padding-bottom: 42%; */
  position: relative;
}
.banner-text{
  position: absolute;
  top: 40%;
  left: 20%;
  font-size: 54px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  font-style: italic;
  color: #FFFFFF;
}

img {
  width: 100%;
}
</style>